import React, { useEffect, useState } from 'react'
import { Box, Collapse, TextField, Stack, Grid, Checkbox, Typography, Paper, TableContainer, Table, TableBody, TableHead, TableRow, TableCell, Button, IconButton, InputAdornment, Dialog, DialogContent, DialogTitle, DialogActions, Divider, Autocomplete, FormControlLabel, FormGroup } from '@mui/material'


import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import EditCalendarTwoToneIcon from '@mui/icons-material/EditCalendarTwoTone';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import OverviewEmployee from './Employee/OverviewEmployee';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useSnackbar } from 'notistack';

import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { fDateTo, fDateZTo } from '../../utils/formatTime';
import { DesktopDatePicker, LocalizationProvider, TimePicker } from '@mui/lab';
import { Form, FormikProvider, useFormik } from 'formik';
import axios from 'axios';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import * as Yup from 'yup';
import OverviewCars from './Cars/OverviewCars';
import { aesApi, aesEncryptECBHex } from '../../query/QueryAES';
import OutSideCarsForm from './Cars/OutSideCarsForm';

export default function ButtonDialogWorkUpdate({ filter, data, booking_id, trip_id, onHandleSubmit, userId, pickup_date, dropoff_date }) {
    const FormSchema = Yup.object().shape({

    });
    const formik = useFormik({
        initialValues: {
            ...data,
            booking_id: booking_id,
            trip_id: trip_id,
            "station_start_datetime": (data.station_start_datetime).replaceAll("T", " ").replaceAll(".000Z", ""),
            "station_end_datetime": (data.station_end_datetime).replaceAll("T", " ").replaceAll(".000Z", ""),
        },
        validationSchema: FormSchema,
        enableReinitialize: true,
        onSubmit: (values, { setValues }) => {
            axios.put(`https://booking.sitbooking.com/booking/book_d`, {
                "groupcode": values.groupcode,
                "guest_count": values.guest_count,
                "booking_id": values.booking_id,
                "trip_id": values.trip_id,
                "line_id": values.line_id,
                "type_car": values.type_car,
                "vehicle_id": values.vehicle_id,
                "driver_id": values.driver_id,
                "reception_id": values.reception_id,
                "station_start": values.station_start,
                "station_start_datetime": (values.station_start_datetime).replaceAll("T", " ").replaceAll(".000Z", ""),
                "station_end_datetime": (values.station_end_datetime).replaceAll("T", " ").replaceAll(".000Z", ""),
                "station_start_flight": values.station_start_flight,
                "station_end": values.station_end,
                "station_end_flight": values.station_end_flight,
                "note": values.note,
                "booking_userid": userId,
                company: values.company,
                outside: values.outside
            })
                .then(res => {
                    handleClickVariant({ message: "บันทึกข้อมูลสำเร็จ", variant: "success" })
                    setOpen(false)
                    onHandleSubmit(booking_id)
                })
                .catch(err => {
                    console.log('err', err)
                })
        }
    });
    const [open, setOpen] = useState(false)
    const handleOpen = () => {
        setOpen(true)
    }
    const handleClose = () => {
        formik.resetForm()
        setOpen(false)

    }
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const handleClickVariant = ({ message, variant }) => {
        enqueueSnackbar(message, { variant: variant, anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, autoHideDuration: 1000 });
    };

    const handleSnackWithAction = ({ message, onHandle }) => {
        closeSnackbar()
        enqueueSnackbar(message, {
            anchorOrigin: {
                horizontal: "center",
                vertical: 'bottom'
            },
            variant: 'default',
            action: (key) => {
                return (
                    <React.Fragment>
                        <Stack direction="row" spacing={1}>
                            <Button
                                size='small'
                                color="error"
                                variant="contained"
                                onClick={() => {
                                    closeSnackbar(key)
                                    onHandle()
                                }}
                            >
                                <CheckRoundedIcon fontSize="small" />
                            </Button>
                            <Button size='small' variant="contained" color="success" onClick={() => closeSnackbar(key)}>
                                <CloseRoundedIcon fontSize="small" />
                            </Button>
                        </Stack>
                    </React.Fragment>
                )
            }
        });
    };

    const onChangeBookingDate = (name, value) => {
        formik.setFieldValue(name, value)
    }
    const handleChangeReception = (reception, type) => {
        if (type === "add") {
            const d = formik.values.reception_id.concat(reception)
            formik.setValues({ ...formik.values, reception_id: d })
        } else {
            const d = formik.values.reception_id.filter(v => v !== reception)
            formik.setValues({ ...formik.values, reception_id: d })
        }
    }
    // const handleChangeCars = (car, driver_id) => {
    //     formik.setValues({ ...formik.values, vehicle_id: car, driver_id: (driver_id !== '' && driver_id !== undefined) ? [driver_id] : formik.values?.driver_id })
    // }

    const handleChangeCars = (car, driver_id) => {
        formik.setValues({ ...formik.values, vehicle_id: car, driver_id: (driver_id !== '' && driver_id !== undefined) ? [driver_id] : formik.values?.driver_id })
    }

    const handleChangeDriver = (driver, type) => {
        if (type === "add") {
            const d = formik.values.driver_id.concat(driver)
            formik.setValues({ ...formik.values, driver_id: d })
        } else {
            const d = formik.values.driver_id.filter(v => v !== driver)
            formik.setValues({ ...formik.values, driver_id: d })
        }
    }
    const handleChangeCarsOutside = (payload) => {
        const { vehicle_id, company, type_car } = payload

        console.log('payload', payload)
        formik.setValues({
            ...formik.values,
            vehicle_id: vehicle_id,
            company: company,
            type_car: type_car,
            driver_id: []
        })
    }

    return (
        <Box>
            <IconButton onClick={handleOpen} size="small"><EditCalendarTwoToneIcon fontSize="inherit" /></IconButton>
            <Dialog
                open={open}
                maxWidth="md"
                fullWidth={true}
                onClose={handleClose}
                slotProps={{
                    backdrop: {
                        style: {
                            // background: "#F8F8FF", opacity: 0.3
                            background: "#a7d8de", opacity: 0.2
                            // background: "#000", opacity: 0.1
                        }
                    }
                }}
            >
                <DialogTitle>รายละเอียด ใบงาน</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <FormikProvider value={formik}>
                            <Form autoComplete="off" noValidate onSubmit={formik.handleSubmit}>
                                <Box>
                                    <Stack>
                                        <Grid container spacing={1} >
                                            <Grid item xs={12} md={12}>
                                                <FormGroup>
                                                    <FormControlLabel
                                                        checked={formik.values.outside === "Y"}
                                                        control={<Checkbox />}
                                                        label="รถภายนอก"
                                                        onChange={() => {
                                                            if (formik.values.outside === "Y") {
                                                                formik.setFieldValue("outside", "N")
                                                            } else {
                                                                formik.setFieldValue("outside", "Y")
                                                            }
                                                            formik.setFieldValue("type_car", "")
                                                            formik.setFieldValue("company", "")
                                                            formik.setFieldValue("vehicle_id", "")
                                                            formik.setFieldValue("driver_id", [])
                                                            formik.setFieldValue("reception_id", [])
                                                        }}
                                                    />
                                                </FormGroup>
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <Grid container spacing={1} >
                                                    <Grid item xs={4} md={4}>
                                                        <TextField size="small" label='ทะเบียนรถ' placeholder='ทะเบียนรถ'
                                                            disabled
                                                            {...formik.getFieldProps('vehicle_id')}
                                                            error={Boolean(formik.touched.vehicle_id && formik.errors.vehicle_id)}
                                                            helperText={formik.touched.vehicle_id && formik.errors.vehicle_id}
                                                            name='vehicle_id' fullWidth
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <InputAdornment position="end" >
                                                                        {
                                                                            (formik.values.outside === "Y") ?
                                                                                <OutSideCarsForm handleChangeCarsOutside={handleChangeCarsOutside} data={
                                                                                    { vehicle_id: formik.values.vehicle_id, company: formik.values.company, type_car: formik.values.type_car }
                                                                                } />
                                                                                :
                                                                                <OverviewCars userId={userId} filter={filter} onHandle={(e, d) => handleChangeCars(e, d)} />
                                                                        }

                                                                    </InputAdornment>
                                                                )
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={4} md={4}>
                                                        <TextField size="small" label='กรุ๊ปโค้ด' placeholder='กรุ๊ปโค้ด'
                                                            {...formik.getFieldProps('groupcode')}
                                                            error={Boolean(formik.touched.groupcode && formik.errors.groupcode)}
                                                            helperText={formik.touched.groupcode && formik.errors.groupcode}
                                                            name='groupcode' fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item xs={4} md={4}>
                                                        <TextField size="small" label='จำนวนคน' placeholder='จำนวนคน'
                                                            {...formik.getFieldProps('guest_count')}
                                                            error={Boolean(formik.touched.guest_count && formik.errors.guest_count)}
                                                            helperText={formik.touched.guest_count && formik.errors.guest_count}
                                                            name='guest_count' fullWidth
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={3} md={3}>
                                                <TextField size="small" label='สถานที่รับ'
                                                    {...formik.getFieldProps('station_start')}
                                                    error={Boolean(formik.touched.station_start && formik.errors.station_start)}
                                                    helperText={formik.touched.station_start && formik.errors.station_start}
                                                    name='station_start'
                                                    fullWidth
                                                // InputProps={{
                                                //     endAdornment: (
                                                //         <InputAdornment position="end" >
                                                //             <IconButton size="small" onClick={() => {
                                                //             }}><SearchIcon fontSize="inherit" /></IconButton>
                                                //         </InputAdornment>
                                                //     )
                                                // }}
                                                />
                                            </Grid>
                                            <Grid item xs={6} md={6}>
                                                <TextField fullWidth
                                                    InputProps={{ inputProps: { min: pickup_date, max: dropoff_date } }}
                                                    size="small" type="datetime-local" name='station_start_datetime'  {...formik.getFieldProps('station_start_datetime')} value={(formik.values?.station_start_datetime).replaceAll("T", " ").replaceAll(".000Z", "")} />
                                            </Grid>
                                            <Grid item xs={3} md={3}>
                                                <TextField size="small" label='flight' placeholder='XX-XXXXX'
                                                    {...formik.getFieldProps('station_start_flight')}
                                                    error={Boolean(formik.touched.station_start_flight && formik.errors.station_start_flight)}
                                                    helperText={formik.touched.station_start_flight && formik.errors.station_start_flight}
                                                    name='station_start_flight' fullWidth />
                                            </Grid>

                                            <Grid item xs={3} md={3}>
                                                <TextField size="small" label='สถานที่ส่ง'
                                                    {...formik.getFieldProps('station_end')}
                                                    error={Boolean(formik.touched.station_end && formik.errors.station_end)}
                                                    helperText={formik.touched.station_end && formik.errors.station_end}
                                                    name='station_end'
                                                    fullWidth
                                                // InputProps={{
                                                //     endAdornment: (
                                                //         <InputAdornment position="end" >
                                                //             <IconButton size="small" onClick={() => {
                                                //             }}><SearchIcon fontSize="inherit" /></IconButton>
                                                //         </InputAdornment>
                                                //     )
                                                // }}
                                                />
                                            </Grid>
                                            <Grid item xs={6} md={6}>
                                                <TextField fullWidth size="small"
                                                    InputProps={{ inputProps: { min: pickup_date, max: dropoff_date } }}
                                                    type="datetime-local" name='station_end_datetime'  {...formik.getFieldProps('station_end_datetime')} value={(formik.values?.station_end_datetime).replaceAll("T", " ").replaceAll(".000Z", "")} />
                                            </Grid>
                                            <Grid item xs={3} md={3}>
                                                <TextField size="small" label='flight'
                                                    {...formik.getFieldProps('station_end_flight')}
                                                    error={Boolean(formik.touched.station_end_flight && formik.errors.station_end_flight)}
                                                    helperText={formik.touched.station_end_flight && formik.errors.station_end_flight}
                                                    name='station_end_flight'
                                                    fullWidth />
                                            </Grid>

                                            {/* ************************พนักงานขับรถ************************ */}
                                            <Grid item xs={12} md={12}>
                                                <OverviewEmployee
                                                    title={"พนักงานขับรถ"}
                                                    onHandle={(e, t) => handleChangeDriver(e, "add")} drivers={formik.values.driver_id} userId={userId} />
                                            </Grid>
                                            {
                                                formik.values?.driver_id?.map((driver, index) => {
                                                    return (
                                                        <Grid item xs={12} md={12}>
                                                            <EmployeeInfo id={driver} onClick={() => handleChangeDriver(driver, "del")} />
                                                            {/* <Stack direction="row" spacing={1}>
                                                                <TextField size="small" disabled label='userid' placeholder='userid' value={driver} fullWidth />
                                                                <Button onClick={() => handleChangeDriver(driver, "del")}>ลบ</Button>
                                                            </Stack> */}
                                                        </Grid>
                                                    )
                                                })
                                            }
                                            {/* ************************พนักงานขับรถ************************ */}
                                            {/* ************************พนักงานต้อนรับ************************ */}
                                            {/* <Grid item xs={12} md={12}>
                                                <OverviewEmployee
                                                    title={"พนักงานต้อนรับ"}
                                                    onHandle={(e, t) => handleChangeReception(e, t)} receptions={formik.values.reception_id} userId={userId} />
                                            </Grid> */}
                                            {
                                                formik.values?.reception_id?.map((reception, index) => {
                                                    return (
                                                        <Grid item xs={12} md={12}>
                                                            <EmployeeInfo id={reception} onClick={() => handleChangeReception(reception, "del")} />
                                                            {/* <Stack direction="row" spacing={1}>
                                                                <TextField size="small" disabled label='userid' placeholder='userid' value={reception} fullWidth />
                                                                <Button onClick={() => handleChangeReception(reception, "del")}>ลบ</Button>
                                                            </Stack> */}
                                                        </Grid>
                                                    )
                                                })
                                            }
                                            {/* ************************พนักงานต้อนรับ************************ */}
                                            <Grid item xs={12} md={12}>
                                                <TextField
                                                    {...formik.getFieldProps('note')}
                                                    error={Boolean(formik.touched.note && formik.errors.note)}
                                                    helperText={formik.touched.note && formik.errors.note}
                                                    name='note'
                                                    size="small" label='หมายเหตุ'
                                                    multiline
                                                    inputProps={{
                                                        style: {
                                                            resize: 'vertical',
                                                        }
                                                    }}
                                                    minRows={3} fullWidth
                                                />
                                            </Grid>
                                        </Grid>
                                    </Stack>
                                </Box>
                            </Form>
                        </FormikProvider>
                    </LocalizationProvider>
                </DialogContent >
                <DialogActions>
                    <Button onClick={() => { formik.submitForm() }}>บันทึก</Button>
                </DialogActions>
            </Dialog >
        </Box >
    )
}


const EmployeeInfo = ({ id, onClick }) => {
    const [userInfo, setUserInfo] = useState(null)

    useEffect(() => {
        axios.get(`https://api.sitbooking.com/booking/userid?userid=${id}`)
            .then(res => {
                setUserInfo(res.data)
            })
            .catch(err => {
                setUserInfo(null)
                console.log('err', err)
            })
    }, [id])


    return (
        <Box>
            <Grid item xs={12} md={12}>
                <Stack direction="row" spacing={1}>
                    <TextField size="small" InputLabelProps={{ shrink: true }} disabled label='userid' placeholder='userid' value={userInfo?.userid} fullWidth />
                    <TextField size="small" InputLabelProps={{ shrink: true }} disabled label='name' placeholder='name' value={userInfo?.fname_lname} fullWidth />
                    <TextField size="small" InputLabelProps={{ shrink: true }} disabled label='phone' placeholder='name' value={userInfo?.phone} fullWidth />
                    <Button onClick={onClick}>ลบ</Button>
                </Stack>
            </Grid>
        </Box>
    )
}
